export const MARKET_PANEL_VIEW_EVENT = 'viewed-market-panel'
export const HOME_INSURANCE_PANEL_VIEW_EVENT = 'viewed-home-insurance-panel'

export const SHOULD_SELL_VIEW_EVENT = 'viewed-should-you-sell'
export const EXPANDED_HOME_APPRECIATION_EVENT = 'expanded-home-appreciation'
export const EXPANDED_CASH_POSITION_EVENT = 'expanded-cash-position'
export const MOVED_CASH_POSITION_SLIDER = 'moved-cash-position-slider'
export const EXPANDED_MARKET_TEMP_SELL_EVENT = 'expanded-market-temp'
